/* eslint-disable import/no-unresolved */
import React from 'react';
import { createRoot } from 'react-dom/client';
// import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root'));
// localhost id= 970403889041-6v0oq5g9992nat39b4gq4k6dhik99tl7.apps.googleusercontent.com
// staging Id= 970403889041-8ep7kl5k53b527132vpno86gv312fjft.apps.googleusercontent.com
// local id2MY= 34193629809-051i0kt2r0rvpn1iqgagimb8ki4euk2d.apps.googleusercontent.com
root.render(
    // <GoogleOAuthProvider clientId='970403889041-8ep7kl5k53b527132vpno86gv312fjft.apps.googleusercontent.com'>
    <App />
    // </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
